import React, { useCallback } from "react";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
import { useDropzone } from "react-dropzone";
import ReactGA from "react-ga";
/** UI Components */
import Button from "component/atoms/button";
// import Dropzone from "component/atoms/dropzone";
import Dropzone from "react-dropzone";
import DCMFileDropzone from "component/atoms/dropzone";
import Provider from "core/provider/";

/** Resources  */
import Icon from "assets/icon";
import "./OverlayInputGuide.styl";
import { render } from "react-dom";

/**
 * @description 프로퍼티 타입 정의
 *
 * @interface IOverlayInputGuideProps
 */
interface IOverlayInputGuideProps {
  /**
   * @description 슬로건 이미지
   */
  onClickUploadDialogBtn: any;
  sarcopeniaMeasureStore: any;
}

/**
 * @description OverlayInputGuide UI Class
 *
 * @class OverlayInputGuide
 * @extends {React.PureComponent<IOverlayInputGuideProps, any>}
 */
@inject("sarcopeniaMeasureStore")
@observer
@Autobind
//const OverlayInputGuide: React.FunctionComponent<IOverlayInputGuideProps> = (
class OverlayInputGuide extends React.Component<IOverlayInputGuideProps> {
  handleDICOMFileDrop(acceptedFiles: any) {
    const { sarcopeniaMeasureStore } = this.props;
    const firstfile = [acceptedFiles[0]];
    // Do something with the files

    // Send user event to Google Analytics
    ReactGA.event({
      category: "Upload DICOM",
      action: "Upload DICOM for test",
    });

    Provider.DICOMFileProvider(firstfile, sarcopeniaMeasureStore);
  }

  render() {
    return (
      <React.Fragment>
        <div className="overlay-input-guide">
          <div className="overlay-area overlay-area--center">
            <div className="overlay-area__content">
              <div className="image text-center" style={{ display: "block" }}>
                <Icon.SVGUploadIcon />
              </div>
              <div className="guide-text text-center">
                <span>{"Drag & Drop DICOM File here."}</span>
                <span>{"or"}</span>
              </div>
              <Dropzone onDrop={this.handleDICOMFileDrop}>
                {({ getRootProps, getInputProps }) => (
                  <div className="open-file-dialog-btn " {...getRootProps()}>
                    <input {...getInputProps()}></input>
                    <Button
                      visible={true}
                      type={"primary"}
                      size={"large"}
                      onClick={this.props.onClickUploadDialogBtn}
                    >
                      Click here
                    </Button>
                  </div>
                )}
              </Dropzone>
              <DCMFileDropzone />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OverlayInputGuide;
